import * as ko from 'knockout'
import { FinishersListViewModel, Params } from './FinishersListViewModel'
import template from './finishers.list.tpl.html'

if (!ko.components.isRegistered('finishers-list')) {
  ko.components.register('finishers-list', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new FinishersListViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
